export default __webpack_public_path__ + "static/media/4.cea68775.wav";